import { Legend, Line, LineChart, XAxis, YAxis } from "recharts";

import { useBreakpoints } from "@sorcery/ui";

export const ManaCurveChart = ({
  data,
}: {
  data: {
    cost: number;
    count: number;
    earthCount: number;
    fireCount: number;
    waterCount: number;
    airCount: number;
  }[];
}) => {
  const { isMd } = useBreakpoints();

  return (
    <div className="flex items-center justify-center">
      <LineChart
        id="mana-curve"
        data={data}
        width={isMd ? 780 : 400}
        height={isMd ? 200 : 180}
        margin={{
          right: 40,
        }}
      >
        <Legend align="right" />
        <XAxis dataKey="cost" />
        <YAxis dataKey="count" />

        <Line
          type="monotone"
          strokeDasharray={"4"}
          dataKey="count"
          name="Total"
          stroke="white"
          dot={false}
        />
        {data?.find((d) => d.earthCount > 0) && (
          <Line type="monotone" dataKey="earthCount" name="Earth" stroke="#9e9f71" dot={false} />
        )}
        {data?.find((d) => d.fireCount > 0) && (
          <Line type="monotone" dataKey="fireCount" name="Fire" stroke="#f87413" dot={false} />
        )}
        {data?.find((d) => d.waterCount > 0) && (
          <Line type="monotone" dataKey="waterCount" name="Water" stroke="#1bdeff" dot={false} />
        )}
        {data?.find((d) => d.airCount > 0) && (
          <Line type="monotone" dataKey="airCount" name="Air" stroke="#aeb5d0" dot={false} />
        )}
      </LineChart>
    </div>
  );
};
